<template>
  <Input v-model="edited" @on-change="handleChange"></Input>
</template>

<script>
export default {
  name: 'SimpleLinkInput',
  data () {
    return {
      edited: ''
    }
  },
  props: {
    link: {
      type: String,
      required: false
    }
  },
  methods: {
    handleChange: function () {
      this.$emit('update:link', this.edited)
    }
  },
  watch: {
    link: function () {
      this.edited = this.link
    }
  }
}
</script>
